import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button } from '@gemini/ui';
import { ArrowRightIcon, CloseIcon } from '@gemini/icons';
import { useTranslation } from 'react-i18next';
import { StyledBox } from './BottomBar.styled';
const BottomBar = ({ handleConfirmation }) => {
    const { t } = useTranslation();
    return (_jsxs(StyledBox, { children: [_jsx(Button, { variant: "tertiary", icon: CloseIcon, iconPosition: "start", size: "48", onPress: () => {
                    window.history.back();
                }, children: t('Cancel') }), _jsx(Button, { variant: "primary", icon: ArrowRightIcon, iconPosition: "end", size: "48", testId: "moveNextButton", onPress: handleConfirmation, children: t('Continue') })] }));
};
export default BottomBar;
